import React from "react";
import "../../PublicHouse.css";

export const ExitButton = ({ handleStepChange }) => {
  return (
    <div className="NextAndPrefButton_main">
      <button className="NextAndPrefButton_button" onClick={() => handleStepChange("exit")}>
        Завершить 
      </button>
      <button className="NextAndPrefButton_button" onClick={() => handleStepChange("prev")}>
        Назад
      </button>
    </div>
  );
};
